import { gql, useQuery } from "@apollo/client";
import { GraphQlPaginated, GraphQlQueryResponse } from "../general/GraphQlQueryResponse";
import { INodeInfo, NodeInfoFragment } from "../node/INodeInfo";


const cmd = gql`
${NodeInfoFragment(true, {
  objectType: 'NodeInfoSubscriberOutput',
  fragmentName: 'NodeSubscriberInfoFragment'
})}

query nodeSubscriberRanking($skip: Float!, $limit: Float!, $search: String) {
  NodeSubscriberRanking(skip: $skip, limit: $limit, search: $search) {
    count
    skip
    limit
    elements {
      ...NodeSubscriberInfoFragment
    }
}
}`;


export function useSubscriberRankingNodes(skip: number, limit: number, search?: string): GraphQlQueryResponse<GraphQlPaginated<INodeInfo>> {
  const query = useQuery(cmd, {
    variables: {
      skip,
      limit,
      search
    },
  },
  );
  const nodeInfo = query.data?.NodeSubscriberRanking;

  return {
    loading: query.loading,
    error: query.error,
    data: nodeInfo,
    refetch: query.refetch,
    fetchMore: query.fetchMore,
    fetchAdditional: async (newSkip: number, search: string) => {
      await query.fetchMore({
        variables: {
          skip: newSkip,
          limit: limit,
          search: search
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const previous = previousResult.NodeSubscriberRanking;
          const more = fetchMoreResult.NodeSubscriberRanking;
          const merged = [...previous.elements, ...more.elements];
          return {
            NodeSubscriberRanking: {
              count: more.count,
              limit: previous.limit + more.limit,
              skip: 0,
              elements: merged
            }
          };
        },
      })
    }
  };
}